export const AIRLINE_SECTION_TYPE_ID = 'airline-section';
export const EXTERNAL_LINK_TYPE_ID = 'external-link';
export const INTERNAL_LINK_TYPE_ID = 'internal-link';
export const TEXT_SECTION_TYPE_ID = 'text-section';
export const ACCORDION_ITEM_TYPE_ID = 'accordion-item';
export const ACCORDION_SECTION_TYPE_ID = 'accordion-section';
export const GENERIC_CONTENT_PAGE_TYPE_ID = 'page';
export const CARD_SECTION_TYPE_ID = 'card-section';
export const CARD_ITEM_TYPE_ID = 'card-item';
export const CONTACT_ITEM_TYPE_ID = 'contact-item';
export const CONTACT_SECTION_TYPE_ID = 'contact-section';
export const QUICK_LINKS_SECTION_TYPE_ID = 'quick-links-section';
export const CALL_TO_ACTION_SECTION_TYPE_ID = 'call-to-action-section';
export const EMAIL_LINK_TYPE_ID = 'email-link';
export const PHONE_LINK_TYPE_ID = 'phone-link';
export const ASSET_LINK_TYPE_ID = 'asset-link';
export const HIGHLIGHT_SECTION_TYPE_ID = 'highlight-section';
export const NEWS_ALERT_TYPE_ID = 'news-alert';
export const FOOTER_TYPE_ID = 'website-footer';
export const AIRLINE_TYPE_ID = 'airline';
export const AIRPORT_TYPE_ID = 'airport';
export const IFRAME_SECTION_TYPE_ID = 'iframe';
export const MENU_ITEM_TYPE_ID = 'menu-item';
export const SUBMENU_ITEM_TYPE_ID = 'submenu-item';
export const SITE_SECTION_ID = 'site-section';
export const CUSTOM_PAGES_CONTAINER_TYPE_ID = 'custom-pages';
export const CAR_RENTAL_ITEM_TYPE_ID = 'car_rental';
export const CAR_RENTAL_SECTION_TYPE_ID = 'car_rental-section';
export const PARKING_LOT_ID = 'parking-lot';
export const UNIFIED_SEARCH_CONFIGURATION_TYPE_ID =
	'unified-search-configuration';

export const CONTENT_CATEGORY_TYPE_ID = 'content-category';
export const FEATURE_ENTRYPOINT_SECTION_TYPE_ID = 'feature-entrypoint-section';
export const PRESS_RELEASE_TYPE_ID = 'press-release';
export const INDUSTRY_NEWS_ITEM_TYPE_ID = 'industry-news-article';
export const IMAGE_SECTION_TYPE_ID = 'image-section';
export const GALLERY_TYPE_ID = 'gallery';
export const GALLERY_ITEM_TYPE_ID = 'gallery-item';

export const SUNSHINE_MEETING_DOCUMENT = 'sunshineMeetingDocument';
export const CONTRACT_DOCUMENT = 'contractDocument';
export const POLICY_DOCUMENT = 'policyDocument';
